<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <div class="float-right">
              <button type="button" class="btn btn-outline-primary btn-sm" (click)="openDialog('createBeneficiary')">
                <i class="fa fa-plus"></i> &nbsp;<span>Add Beneficiary</span></button></div>
          </div>
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive" *ngIf="showData">
              <table id="all-beneficiaries" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th class="no-sort" width="5%"></th>
                  <th>Action</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Bank Name</th>
                  <th>Account Number</th>
                  <th>Account Name</th>
                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th class="no-sort" ></th>
                  <th>Action</th>

                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Bank Name</th>
                  <th>Account Number</th>
                  <th>Account Name</th>
                </tr>
                </tfoot>
                <tbody>

                <tr *ngFor="let beneficiary of beneficiaries;let i = index;">

                  <td class="details-control" [id]="'td-' + i" ></td>
                  <td>
                    <div>
                        <span role="button" data-balloon="Edit Beneficary" data-balloon-pos="up" (click)="triggerEdit(beneficiary)">
                                          <i class="fa fa-edit text-info"></i>
                                        </span>&nbsp;&nbsp;
                      <span role="button" data-balloon="Delete Beneficary" data-balloon-pos="up" (click)="deleteBeneficiary(beneficiary)">
                        <i class="fa fa-trash text-danger"></i>
                      </span>
                    </div>
                  </td>
                  <td>&nbsp;
                    {{ beneficiary?.first_name }}
                  </td>
                  <td>{{ beneficiary?.last_name }}</td>
                  <td>{{ beneficiary?.email }}</td>
                  <td>{{ beneficiary?.phone_no }}</td>
                  <td>{{ beneficiary?.bank_name }}</td>
                  <td>{{ beneficiary?.account_no }}</td>
                  <td>{{ beneficiary?.account_name }}</td>

                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

    </div>



  </div>
</div>




<!-- Beneficiary Modal -->
<app-modal [modalId]="'createBeneficiary'" [modalTitle]="modal.title" >
      <form class="form-auth-small" #signupForm="ngForm" (ngSubmit)="createBeneficiary()">

        <div class="modal-body">
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="first_name" class="control-label ">First Name</label>
              <input type="text" class="form-control" placeholder="First Name"
                     #first_name="ngModel"
                     id="first_name"
                     [(ngModel)]="beneficiary.first_name" [ngModelOptions]="{standalone: true}" required>
              <div class="text-danger" *ngIf="first_name.errors && (first_name.dirty || first_name.touched)">
                  <span class="validation-message" [hidden]="!first_name.hasError('required')">
                    First Name is required</span>
              </div>
            </div>



            <div class="form-group">
              <label for="phone_no" class="control-label ">Phone Number</label>
              <input type="text" class="form-control" placeholder="Phone Number"
                     #phone_no="ngModel"
                     id="phone_no"
                     [(ngModel)]="beneficiary.phone_no" [ngModelOptions]="{standalone: true}" required>
              <div class="text-danger" *ngIf="phone_no.errors && (phone_no.dirty || phone_no.touched)">
                  <span class="validation-message" [hidden]="!phone_no.hasError('required')">
                    Phone Number is required</span>
              </div>
            </div>




            <div class="form-group">
              <label for="selectBank" class="control-label ">Bank Name</label>
              <ng-select [items]="allBanks" class="ng-select-form" required id="selectBank"
                         [notFoundText]="'No data available'"
                         [placeholder]="'Select Bank'" #selectBank="ngModel"
                         bindLabel="bank_name"
                         bindValue="id" [(ngModel)]="beneficiary.bank_id" [ngModelOptions]="{standalone: true}"
                         [multiple]="false" >
              </ng-select>
              <div class="text-danger" *ngIf="selectBank.errors && (selectBank.dirty || selectBank.touched)">
                  <span class="validation-message" [hidden]="!selectBank.hasError('required')">
                    Bank Name is required</span>
              </div>
            </div>

            <div class="form-group">
              <label for="account_name" class="control-label ">Account Name</label>
              <input type="text" class="form-control" placeholder="Account Name"
                     #account_name="ngModel"
                     id="account_name"
                     [(ngModel)]="beneficiary.account_name" [ngModelOptions]="{standalone: true}" required>
              <div class="text-danger" *ngIf="account_name.errors && (account_name.dirty || account_name.touched)">
                  <span class="validation-message" [hidden]="!account_name.hasError('required')">
                    Account Name is required</span>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="last_name" class="control-label ">Last Name</label>
              <input type="text" class="form-control" placeholder="Last Name"
                     #last_name="ngModel"
                     id="last_name"
                     [(ngModel)]="beneficiary.last_name" [ngModelOptions]="{standalone: true}" required>
              <div class="text-danger" *ngIf="last_name.errors && (last_name.dirty || last_name.touched)">
                  <span class="validation-message" [hidden]="!last_name.hasError('required')">
                    Last Name is required</span>
              </div>
            </div>

            <div class="form-group">
              <label for="email" class="control-label ">Email</label>
              <input type="email" class="form-control" placeholder="Email"
                     #email="ngModel"
                     id="email"
                     [(ngModel)]="beneficiary.email" [ngModelOptions]="{standalone: true}" required [pattern]="EMAIL_VALIDATION">
              <div class="text-danger" *ngIf="email.errors && (email.dirty || email.touched)">
                  <span class="validation-message" [hidden]="!email.hasError('required')">
                    Email is required</span>
                <span class="validation-message" [hidden]="!email.hasError('pattern')">
                    Invalid Email address</span>
              </div>
            </div>






            <div class="form-group">
              <label for="account_number" class="control-label ">Account Number</label>
              <input type="text" class="form-control" placeholder="Account Number"
                     #account_number="ngModel"
                     id="account_number"
                     [(ngModel)]="beneficiary.account_no" [ngModelOptions]="{standalone: true}" required>
              <div class="text-danger" *ngIf="account_number.errors && (account_number.dirty || account_number.touched)">
                  <span class="validation-message" [hidden]="!account_number.hasError('required')">
                    Account Number is required</span>
              </div>
            </div>


          </div>
        </div>

        </div>

        <div class="modal-footer">
          <button type="submit" *ngIf="!loaders.saving" [disabled]="first_name.errors || last_name.errors || email.errors" class="btn btn-primary">{{modal.btnText}}</button>
          <span *ngIf="loaders.saving" class="btn btn-primary">Loading&nbsp;<i class="fa fa-spin fa-spinner"></i></span>
          <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="resetForm()">CLOSE</button>
        </div>
      </form>
</app-modal>


